export default {
    'Exclusivo': 'Exclusivo', 'Diferenciado': 'Diferenciado', 'Sem diferenciação': 'Sem diferenciação'
}
